import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToasterMsgService {

  constructor() { }

  private _toasterMsg = new BehaviorSubject<string>(null);
  toasterMsg = this._toasterMsg.asObservable();

  setMessage(message) {
    this._toasterMsg.next(message);
  }

  getMessage() {
    return this._toasterMsg;
  }

  private _toasterConfig = new BehaviorSubject<object>({});
  toasterConfig = this._toasterConfig.asObservable();

  setToasterConfig(obj) {
    this._toasterConfig.next(obj);
  }

  getToasterConfig() {
    return this._toasterConfig;
  }
}
